module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//btn-2.png?v=1ef77315";